export default defineNuxtPlugin((nuxtApp) => {
    const route = useRoute();
    const runtimeConfig = useRuntimeConfig();
  
    const updateCanonicalUrl = () => {
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      const currentUrl = `${runtimeConfig.public.appBase}${route.fullPath}`;
  
      if (canonicalLink) {
        // Update the href of the existing canonical link
        canonicalLink.setAttribute("href", currentUrl);
      } else {
        // Create a new canonical link if it doesn't exist
        const link = document.createElement("link");
        link.rel = "canonical";
        link.href = currentUrl;
        document.head.appendChild(link);
      }
    };
  
    // Set the canonical URL when the app is mounted
    nuxtApp.hook("app:mounted", () => {
      updateCanonicalUrl();
    });
  
    // Update the canonical URL on route changes
    nuxtApp.hook("page:finish", () => {
      updateCanonicalUrl();
    });
});